import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from '@/store';
import App from './App';
import './index.css';

createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <App />
  </Provider>
);

                const loaderWrapper = document.getElementById("apper-loader-wrapper");
                if (loaderWrapper) {
                    loaderWrapper.classList.add("apper-loader-hidden"); // Add a class to hide
                    // Optional: Remove element after transition to clean up DOM
                    loaderWrapper.addEventListener("transitionend", () => {
                        loaderWrapper?.remove();
                    });
                }
            